module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step3_Image7.1bbbf516.jpg";